import { PARTNERS, AUTHORITIES, SOCIAL } from "../../lib/constants";
import { FooterOrganization } from "./footer-organization";
import { FooterSocial } from "./footer-social";
import { FooterLegal } from "./footer-legal";

function Footer() {
  return (
    <footer className="relative border-t bg-background font-inter">
      <div className="mx-auto px-4 flex flex-col justify-center lg:flex-row lg:justify-between">
        <ul className="list-none grid grid-cols-4 gap-8 items-center p-4 lg:flex lg:flex-row 2xl:pl-0">
          {PARTNERS.map((organization) => {
            return (
              <li key={organization.id} className="grow-0">
                <FooterOrganization organization={organization} />
              </li>
            );
          })}
        </ul>
        <ul className="list-none flex flex-row gap-6 justify-center items-center border-t p-4 2xl:pr-0 lg:ml-auto lg:border-l lg:border-t-0">
          {AUTHORITIES.map((organization) => {
            return (
              <li key={organization.id} className="grow-0">
                <FooterOrganization organization={organization} />
              </li>
            );
          })}
        </ul>
      </div>
      <div className="relative p-4 text-gray-400 border-t">
        <div className="max-w-screen-2xl mx-auto">
          <div className="flex flex-col gap-6 lg:flex-row lg:justify-between">
            <div className="flex flex-col lg:flex-row gap-8 items-center justify-center">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 170 72"
                  width={120}
                  preserveAspectRatio="xMidYMid slice"
                  fill="fill-current"
                >
                  <path fill="#50ACC1" d="M4.056 64H169.24v8H4.056z" />
                  <path
                    fill="#77AD54"
                    d="M137.803 10.366c-.564 0-1.916 1.69-2.592 2.48-1.803 2.253-4.619 5.633-8.901 4.732-4.282-.902-5.409-5.184-6.085-8-.225-1.015-.788-3.155-1.239-3.38L120.338 0c4.282.901 5.409 5.183 6.085 8 .225 1.014.788 3.155 1.239 3.38.563 0 1.915-1.69 2.592-2.479 1.802-2.253 4.619-5.633 8.901-4.732z"
                  />
                  <path
                    fill="#175D71"
                    d="M148.169 50.254v-7.212h12.282v-7.324h-10.028v-7.324h10.028v-7.21h-12.282v-7.212h21.07v36.282zM144.338 43.042c-.563-.225-1.577-2.14-2.141-3.267-1.465-2.93-3.605-7.212-8.45-7.212-4.846 0-7.099 4.395-8.451 7.212-.564 1.014-1.578 3.155-2.254 3.38-.563-.225-1.69-2.366-2.141-3.38-1.464-2.93-3.605-7.212-8.563-7.212-4.845 0-7.099 4.395-8.563 7.212-.564 1.014-1.578 3.042-2.254 3.267v7.212c4.845 0 7.099-4.395 8.564-7.212.563-1.014 1.577-3.155 2.253-3.38.563.225 1.69 2.366 2.141 3.38 1.465 2.93 3.606 7.212 8.563 7.212 4.845 0 7.099-4.395 8.564-7.212.563-1.014 1.577-3.155 2.253-3.38.564.225 1.69 2.366 2.141 3.38 1.465 2.93 3.606 7.212 8.451 7.212v-7.212zM76.845 50.254V13.972h21.183v7.211H85.634v7.211h10.028v7.324H85.634v7.324h12.281v7.212zM64.225 50.254 56 35.944h-3.155v14.31h-8.45V13.972h13.52c1.578 0 3.043.225 4.395.789 1.352.563 2.591 1.239 3.718 2.14 1.127.902 1.916 2.029 2.592 3.493.676 1.353 1.014 2.93 1.014 4.62 0 2.14-.564 4.056-1.578 5.634-1.126 1.577-2.366 2.704-3.943 3.493l9.915 16.225h-9.803zM61.183 24.9c0-1.352-.45-2.366-1.465-3.042-.901-.676-2.028-1.014-3.155-1.014h-3.718v8.113h3.718c1.127 0 2.141-.338 3.155-1.014 1.014-.564 1.465-1.578 1.465-3.043M39.324 32c0 2.93-.563 5.521-1.69 7.887-1.127 2.367-2.592 4.395-4.395 5.972-1.802 1.69-3.943 2.93-6.31 3.831a20.1 20.1 0 0 1-7.323 1.352c-2.48 0-4.958-.45-7.324-1.352-2.367-.901-4.395-2.14-6.197-3.83-1.803-1.691-3.268-3.606-4.395-5.973S0 34.93 0 32s.563-5.521 1.69-7.887 2.592-4.395 4.395-5.972 3.83-2.93 6.197-3.831a20.1 20.1 0 0 1 7.324-1.352c2.478 0 4.957.45 7.324 1.352 2.366.901 4.394 2.14 6.31 3.83 1.802 1.578 3.267 3.607 4.394 5.973 1.127 2.479 1.69 5.07 1.69 7.887m-9.014 0c0-1.69-.338-3.268-.901-4.62-.564-1.352-1.353-2.591-2.367-3.493-1.014-1.014-2.14-1.69-3.38-2.253s-2.592-.789-3.944-.789-2.704.225-3.943.789c-1.24.563-2.367 1.24-3.38 2.253-1.015 1.014-1.803 2.141-2.367 3.493A12.1 12.1 0 0 0 9.127 32c0 1.69.338 3.268.901 4.62.564 1.352 1.352 2.591 2.366 3.605s2.141 1.69 3.38 2.254c1.24.563 2.592.789 3.944.789s2.704-.226 3.944-.79c1.24-.562 2.366-1.239 3.38-2.253s1.803-2.14 2.366-3.605c.676-1.352.902-2.817.902-4.62"
                  />
                </svg>
              </div>
            </div>
            <div className="flex justify-center lg:justify-end">
              <ul className="list-none flex flex-row gap-4 items-center">
                {SOCIAL.map((social) => {
                  return (
                    <li key={social.id}>
                      <FooterSocial social={social} />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        <FooterLegal />
      </div>
    </footer>
  );
}

export { Footer };
